// // import React, { useEffect, useRef } from "react";
// // import "./Countdown.css";

// // function Countdown() {
// //   const daysRef = useRef(null);
// //   const hoursRef = useRef(null);
// //   const minutesRef = useRef(null);
// //   const secondsRef = useRef(null);

// //   useEffect(() => {
// //     const second = 1000,
// //       minute = second * 60,
// //       hour = minute * 60,
// //       day = hour * 24;

// //     let targetDate = "Apr 5, 2025 00:00:00", // Cập nhật ngày hợp lệ
// //       countDown = new Date(targetDate).getTime();

// //     const x = setInterval(() => {
// //       let now = new Date().getTime(),
// //         distance = countDown - now;

// //       if (daysRef.current)
// //         daysRef.current.innerText = Math.floor(distance / day);
// //       if (hoursRef.current)
// //         hoursRef.current.innerText = Math.floor((distance % day) / hour);
// //       if (minutesRef.current)
// //         minutesRef.current.innerText = Math.floor((distance % hour) / minute);
// //       if (secondsRef.current)
// //         secondsRef.current.innerText = Math.floor((distance % minute) / second);

// //       if (distance < 0) {
// //         clearInterval(x);
// //       }
// //     }, 1000);

// //     return () => clearInterval(x);
// //   }, []);

// //   return (
// //     <div id="countdown" className="section-padding bg-img bg-fixed">
// //       <div className="container">
// //         <div className="row">
// //           <div className="section-head col-md-12">
// //             <h4>Chúng tôi sẽ về chung nhà</h4>
// //           </div>
// //         </div>
// //         <div className="row">
// //           <div className="col-md-12">
// //             <ul>
// //               <li>
// //                 <span ref={daysRef}></span> Ngày
// //               </li>
// //               <li>
// //                 <span ref={hoursRef}></span> Giờ
// //               </li>
// //               <li>
// //                 <span ref={minutesRef}></span> Phút
// //               </li>
// //               <li>
// //                 <span ref={secondsRef}></span> Giây
// //               </li>
// //             </ul>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Countdown;

// import React, { useEffect, useRef, useState } from "react";
// import "./Countdown.css";

// function Countdown() {
//   const daysRef = useRef(null);
//   const hoursRef = useRef(null);
//   const minutesRef = useRef(null);
//   const secondsRef = useRef(null);
//   const [hearts, setHearts] = useState([]);

//   // Tạo hiệu ứng trái tim chuyển động
//   useEffect(() => {
//     // Tạo trái tim mới mỗi 2 giây
//     const heartInterval = setInterval(() => {
//       const newHeart = {
//         id: Date.now(),
//         left: Math.random() * 100,
//         animationDuration: 3 + Math.random() * 4,
//       };

//       setHearts((prevHearts) => [...prevHearts, newHeart]);

//       // Xóa trái tim cũ để tránh quá nhiều trái tim
//       setTimeout(() => {
//         setHearts((prevHearts) =>
//           prevHearts.filter((heart) => heart.id !== newHeart.id)
//         );
//       }, newHeart.animationDuration * 1000);
//     }, 2000);

//     return () => clearInterval(heartInterval);
//   }, []);

//   useEffect(() => {
//     const second = 1000,
//       minute = second * 60,
//       hour = minute * 60,
//       day = hour * 24;

//     let targetDate = "Apr 5, 2025 00:00:00", // Cập nhật ngày hợp lệ
//       countDown = new Date(targetDate).getTime();

//     const x = setInterval(() => {
//       let now = new Date().getTime(),
//         distance = countDown - now;

//       if (daysRef.current)
//         daysRef.current.innerText = Math.floor(distance / day);
//       if (hoursRef.current)
//         hoursRef.current.innerText = Math.floor((distance % day) / hour);
//       if (minutesRef.current)
//         minutesRef.current.innerText = Math.floor((distance % hour) / minute);
//       if (secondsRef.current)
//         secondsRef.current.innerText = Math.floor((distance % minute) / second);

//       if (distance < 0) {
//         clearInterval(x);
//       }
//     }, 1000);

//     return () => clearInterval(x);
//   }, []);

//   return (
//     <div
//       id="wedding-countdown"
//       className="wedding-countdown-section bg-img bg-fixed"
//     >
//       {/* Floating hearts animation */}
//       <div className="floating-hearts-container">
//         {hearts.map((heart) => (
//           <div
//             key={heart.id}
//             className="floating-heart"
//             style={{
//               left: `${heart.left}%`,
//               animationDuration: `${heart.animationDuration}s`,
//             }}
//           >
//             ❤️
//           </div>
//         ))}
//       </div>

//       <div className="container">
//         <div className="row">
//           <div className="wedding-title col-md-12">
//             <h2 className="wedding-heading">Đếm ngược đến ngày hạnh phúc</h2>
//             <div className="wedding-decoration">
//               <span className="decoration-line"></span>
//               <span className="decoration-heart">💕</span>
//               <span className="decoration-line"></span>
//             </div>
//             <h3 className="wedding-subheading">Chúng tôi sẽ về chung nhà</h3>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-md-12">
//             <div className="wedding-countdown-wrapper">
//               <ul className="wedding-countdown-timer">
//                 <li className="countdown-item">
//                   <div className="countdown-value">
//                     <span ref={daysRef}></span>
//                   </div>
//                   <div className="countdown-label">Ngày</div>
//                 </li>
//                 <li className="countdown-item">
//                   <div className="countdown-value">
//                     <span ref={hoursRef}></span>
//                   </div>
//                   <div className="countdown-label">Giờ</div>
//                 </li>
//                 <li className="countdown-item">
//                   <div className="countdown-value">
//                     <span ref={minutesRef}></span>
//                   </div>
//                   <div className="countdown-label">Phút</div>
//                 </li>
//                 <li className="countdown-item">
//                   <div className="countdown-value">
//                     <span ref={secondsRef}></span>
//                   </div>
//                   <div className="countdown-label">Giây</div>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Countdown;

import React, { useEffect, useRef, useState } from "react";
import "./Countdown.css";

function WeddingCountdown() {
  const daysRef = useRef(null);
  const hoursRef = useRef(null);
  const minutesRef = useRef(null);
  const secondsRef = useRef(null);
  const [floatingItems, setFloatingItems] = useState([]);

  // Tạo hiệu ứng trái tim và nơ chuyển động
  useEffect(() => {
    // Tạo trái tim hoặc nơ mới mỗi 1.5 giây
    const floatingInterval = setInterval(() => {
      const isHeart = Math.random() > 0.4; // 60% là trái tim, 40% là nơ
      const newItem = {
        id: Date.now(),
        left: Math.random() * 100,
        size: Math.random() * 0.5 + 0.7, // Kích thước ngẫu nhiên từ 0.7 đến 1.2
        rotation: Math.random() * 40 - 20, // Xoay ngẫu nhiên từ -20 đến 20 độ
        animationDuration: 3 + Math.random() * 5,
        type: isHeart ? "heart" : "bow",
        delay: Math.random() * 2, // Thêm độ trễ ngẫu nhiên
      };

      setFloatingItems((prevItems) => [...prevItems, newItem]);

      // Xóa item cũ để tránh quá nhiều item
      setTimeout(() => {
        setFloatingItems((prevItems) =>
          prevItems.filter((item) => item.id !== newItem.id)
        );
      }, (newItem.animationDuration + newItem.delay) * 1000);
    }, 1500);

    return () => clearInterval(floatingInterval);
  }, []);

  useEffect(() => {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

    let targetDate = "Apr 5, 2025 00:00:00", // Ngày cưới
      countDown = new Date(targetDate).getTime();

    const x = setInterval(() => {
      let now = new Date().getTime(),
        distance = countDown - now;

      if (daysRef.current)
        daysRef.current.innerText = Math.floor(distance / day);
      if (hoursRef.current)
        hoursRef.current.innerText = Math.floor((distance % day) / hour);
      if (minutesRef.current)
        minutesRef.current.innerText = Math.floor((distance % hour) / minute);
      if (secondsRef.current)
        secondsRef.current.innerText = Math.floor((distance % minute) / second);

      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);

    return () => clearInterval(x);
  }, []);

  return (
    <div
      id="wedding-countdown"
      className="wedding-countdown-section bg-img bg-fixed"
    >
      {/* Floating hearts and bows animation */}
      <div className="floating-items-container">
        {floatingItems.map((item) => (
          <div
            key={item.id}
            className={`floating-item ${
              item.type === "heart" ? "floating-heart" : "floating-bow"
            }`}
            style={{
              left: `${item.left}%`,
              transform: `scale(${item.size}) rotate(${item.rotation}deg)`,
              animationDuration: `${item.animationDuration}s`,
              animationDelay: `${item.delay}s`,
            }}
          >
            {item.type === "heart" ? "🎀" : "🎀"}
          </div>
        ))}
      </div>

      <div className="wedding-container">
        <div className="wedding-row">
          <div className="wedding-title wedding-col-md-12">
            <h2 className="wedding-heading">Đếm ngược đến ngày hạnh phúc</h2>
            <div className="wedding-decoration">
              <span className="decoration-line"></span>
              <span className="decoration-icon">💕</span>
              <span className="decoration-line"></span>
            </div>
            <h3 className="wedding-subheading">Chúng tôi sẽ về chung nhà</h3>
          </div>
        </div>
        <div className="wedding-row">
          <div className="wedding-col-md-12">
            <div className="wedding-countdown-wrapper">
              <ul className="wedding-countdown-timer">
                <li className="countdown-item">
                  <div className="countdown-value">
                    <span ref={daysRef}></span>
                  </div>
                  <div className="countdown-label">Ngày</div>
                </li>
                <li className="countdown-item">
                  <div className="countdown-value">
                    <span ref={hoursRef}></span>
                  </div>
                  <div className="countdown-label">Giờ</div>
                </li>
                <li className="countdown-item">
                  <div className="countdown-value">
                    <span ref={minutesRef}></span>
                  </div>
                  <div className="countdown-label">Phút</div>
                </li>
                <li className="countdown-item">
                  <div className="countdown-value">
                    <span ref={secondsRef}></span>
                  </div>
                  <div className="countdown-label">Giây</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .wedding-countdown-section {
          background-image: url("/wedding-background.jpg");
          background-size: cover;
          padding: 100px 0;
          position: relative;
          overflow: hidden;
        }

        .wedding-container {
          width: 85%;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .wedding-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
        }

        .wedding-col-md-12 {
          flex: 0 0 100%;
          max-width: 100%;
          text-align: center;
        }

        .wedding-title {
          margin-bottom: 40px;
        }

        .wedding-heading {
          font-size: 36px;
          color: #ff758c;
          margin-bottom: 15px;
          font-family: "Playfair Display", serif;
        }

        .wedding-subheading {
          font-size: 24px;
          color: #333;
          margin-top: 15px;
        }

        .wedding-decoration {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 15px 0;
        }

        .decoration-line {
          height: 1px;
          width: 80px;
          background: linear-gradient(90deg, transparent, #ff758c, transparent);
        }

        .decoration-icon {
          font-size: 24px;
          margin: 0 15px;
          animation: pulse 2s infinite ease-in-out;
        }

        .wedding-countdown-wrapper {
          background-color: rgba(255, 255, 255, 0.9);
          border-radius: 15px;
          padding: 40px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          position: relative;
          overflow: hidden;
        }

        .wedding-countdown-wrapper::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 5px;
          background: linear-gradient(
            90deg,
            #ff758c,
            #ff7eb3,
            #ff7eb3,
            #ff758c
          );
        }

        .wedding-countdown-timer {
          display: flex;
          justify-content: center;
          list-style-type: none;
          padding: 0;
          margin: 0;
        }

        .countdown-item {
          flex: 1;
          max-width: 150px;
          margin: 0 15px;
          text-align: center;
        }

        .countdown-value {
          background: linear-gradient(135deg, #ff758c, #ff7eb3);
          color: white;
          font-size: 48px;
          font-weight: 700;
          border-radius: 10px;
          padding: 20px 0;
          margin-bottom: 10px;
          box-shadow: 0 5px 15px rgba(255, 117, 140, 0.3);
          position: relative;
          overflow: hidden;
        }

        .countdown-value::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 30%;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 0 0 50% 50%;
        }

        .countdown-label {
          font-size: 18px;
          color: #666;
          font-weight: 500;
        }

        /* Floating items container */
        .floating-items-container {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }

        /* Common styles for floating items */
        .floating-item {
          position: absolute;
          bottom: -50px;
          font-size: 30px;
          opacity: 0;
          animation-name: float-up;
          animation-fill-mode: forwards;
          animation-timing-function: ease-out;
        }

        /* Heart specific styles */
        .floating-heart {
          color: #ff758c;
        }

        /* Bow specific styles */
        .floating-bow {
          color: #ff4081;
        }

        @keyframes float-up {
          0% {
            transform: translateY(0) rotate(0deg) scale(1);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          100% {
            transform: translateY(-100vh) rotate(var(--rotate, 20deg))
              scale(var(--scale, 1));
            opacity: 0;
          }
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }

        @media (max-width: 768px) {
          .countdown-item {
            margin: 0 10px;
          }

          .countdown-value {
            font-size: 36px;
            padding: 15px 0;
          }

          .countdown-label {
            font-size: 16px;
          }

          .wedding-heading {
            font-size: 28px;
          }

          .wedding-subheading {
            font-size: 20px;
          }
        }
      `}</style>
    </div>
  );
}

export default WeddingCountdown;
